export interface EventDetail {
  field: string;
  value: string | Array<string>;
  expanded?: boolean;
}

export enum EventType {
  ALERT = 'alert',
  XALERT = 'xalert',
}
